export default __webpack_public_path__ + "static/media/Productivity.eec460f9.svg";